/**
 * Top-level error boundary. A render crash must never leave a blank page in
 * front of a restaurant guest — it shows a Persian recovery screen instead.
 */
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Icon } from '@/components/icons/Icon';
import './ErrorBoundary.css';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Left as console output on purpose: no telemetry endpoint in the MVP.
    console.error('[garson] render error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="gs-crash" dir="rtl">
        <div className="gs-crash-card">
          <span className="gs-crash-mark" aria-hidden="true"><Icon name="cloche" size={34} weight={1.5} /></span>
          <h1>مشکلی پیش آمد</h1>
          <p>صفحه به‌درستی بار نشد. یک‌بار بازخوانی کنید؛ اگر ادامه داشت، به کارکنان سالن بگویید.</p>
          <button type="button" className="gs-crash-button" onClick={() => window.location.reload()}>
            <Icon name="refresh" size={18} weight={1.9} />
            بازخوانی صفحه
          </button>
        </div>
      </div>
    );
  }
}
